import { SOURCE_ID, addSource, getAddBefore } from "./geoFeaturesSource";

/* USGS geologic map faults (TX, NM, LA). */
const LAYER_ID = "faults";

const SOURCE_LAYER_FAULTS = "geo_features_faults";

const LAYER_FAULTS_ID = "Faults";

const addLayers = (mapRef) => {
  const map = mapRef.current;

  if (!map.getLayer(LAYER_FAULTS_ID)) {
    map.addLayer(
      {
        id: LAYER_FAULTS_ID,
        type: "line",
        source: SOURCE_ID,
        "source-layer": SOURCE_LAYER_FAULTS,
        layout: {
          visibility: "none",
          "line-cap": "round",
        },
        paint: {
          "line-color": "#8c510a",
          "line-width": ["interpolate", ["linear"], ["zoom"], 5, 0.3, 12, 1],
        },
      },
      getAddBefore(map)
    );
  }
};

const addAll = (mapRef) => {
  addSource(mapRef);
  addLayers(mapRef);
};

const setAnnotationVisibility = (action) => {
  const { mapRef, value } = action;

  if (!mapRef || !mapRef.current) return;

  const map = mapRef.current;

  if (map.getLayer(LAYER_FAULTS_ID)) {
    map.setLayoutProperty(
      LAYER_FAULTS_ID,
      "visibility",
      value ? "visible" : "none"
    );
  }
};

export {
  SOURCE_ID,
  LAYER_ID,
  LAYER_FAULTS_ID,
  addAll,
  setAnnotationVisibility,
};
